module.exports = __webpack_public_path__ + "static/media/piper-notificacion-ico.63152de5.svg";